import { EventType } from './event-type.interface';

export const FAN: EventType = {
  name: 'Fan',
  description: 'When a Fan starts, stops or changes speed',
  route: 'fan',
  category: 'Fan',
  icon: 'fan',
  order: 3,
  whitelist: [
    {
      proxy: 'relaysingle_fan_c4',
      events: [1, 2]
    },
    {
      proxy: 'fan',
      events: [101, 102, 103]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/fan.type.ts